import { MagnifyingGlass, X } from "@phosphor-icons/react";

export default function MessageSearch({ value, onChange, testid = "msg-search" }) {
  return (
    <div className="relative flex-1 min-w-[180px]">
      <MagnifyingGlass size={14} className="absolute left-3 top-1/2 -translate-y-1/2" style={{ color: "var(--text-dim)" }} />
      <input value={value} onChange={(e) => onChange(e.target.value)} placeholder="Search subject or message text…"
        data-testid={testid} className="w-full pl-9 pr-9 py-2 text-sm" />
      {value && (
        <button type="button" onClick={() => onChange("")} data-testid={`${testid}-clear`}
          className="absolute right-2 top-1/2 -translate-y-1/2 p-1" title="Clear search">
          <X size={12} weight="bold" />
        </button>
      )}
    </div>
  );
}
